import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import * as Sentry from '@sentry/angular';

import { AuthService } from '../services';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService, private storage: Storage) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err) => {
        // Capturar errores HTTP con Sentry solo en producción
        if (environment.production) {
          Sentry.captureException(err, {
            tags: {
              section: 'http_interceptor'
            },
            extra: {
              url: request.url,
              method: request.method,
              status: err.status,
              statusText: err.statusText
            }
          });
        }

        if ([401, 403].includes(err.status)) {
          this.authService.logout()
        } else if (err.statusText == 'Unknown Error') {
          this.storage.remove(environment.localStorage)
        }

        return throwError(err)
      })
    )
  }
}
